const FILTER_OPTIONS = Object.freeze({
  activity: {
    active: 'activity___active',
    terminated: 'activity___terminated',
    all: 'activity___all',
  },
  employees: {
    directManaged: 'employees___reporting_to_me_directly',
    managed: 'employees___reporting_to_me',
    timeoffSupervisor: 'employees___timeoff_managed_by_me',
    locationIssues: 'employees___location_issues',
    away: 'employees___away',
    awayThisMonth: 'employees___away_this_month',
    welcomeSpaceAccess: 'employees___with_welcome_space_access',
  },
  status: {
    clockedIn: 'status___clocked_in',
    onBreak: 'status___on_break',
    shiftConflicts: 'status___shift_conflicts',
  },
  location: (id: string) => `location___${id}`,
  team: (id: string) => `team___${id}`,
  legalEntity: (id: string) => `legalEntity___${id}`,
})

export default FILTER_OPTIONS
